module.exports = __webpack_public_path__ + "static/media/background_2.49e3d6d6.jpg";